export default __webpack_public_path__ + "static/media/circle.311c8160.svg";